import React, { createContext, useEffect, useState } from "react";

export const LocationContext = createContext(null);

export const LocationProvider = ({ children }) => {

  const defaultLocation = {
    lat: "",
    lng: "",
    single_address:"Nashik",
    address: "Nashik city 422001",
    city_id: 10,
    town_id:97,
  };


  const [cur_location, setCurLocation] = useState(() => {
    const saved = sessionStorage.getItem("cur_location");
    return saved ? JSON.parse(saved) : { ...defaultLocation };
  });

const [locationChangedByUser, setLocationChangedByUser] = useState(false);

  // On first load, only ask for location if sessionStorage empty
  useEffect(() => {
    const saved = sessionStorage.getItem("cur_location");
    
    if (!saved) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          fetchAddress(lat, lng);
        },
        (err) => {
          const defaultLocation = {
            lat: "",
            lng: "",
            single_address:"Nashik",
            address: "Nashik city 422001",
            city_id: 10,
            town_id:97,
          };
          setCurLocation(defaultLocation); // state updated
          sessionStorage.setItem("cur_location", JSON.stringify(defaultLocation));
        }
      );
    }
  }, []);

  const getCurrentLocation = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        fetchAddress(lat, lng);
      },
      (err) => alert("Location permission denied")
    );
  };

  const fetchAddress = async (lat, lng) => {
    const res = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyDeZEUk4duqBvkXPYcZL-FR3IgCK7EA9bM`
    );
    const data = await res.json();
    const components = data.results[0].address_components;

     const town =
    components.find(c =>
      c.types.includes("locality") ||
      c.types.includes("sublocality") ||
      c.types.includes("administrative_area_level_2")
    )?.long_name || "";

  const pincode =
    components.find(c => c.types.includes("postal_code"))?.long_name || "";
    var sortedAddress=town+' '+pincode;
    if (data.results?.length) {
      const newLocation = {
        lat,
        lng,
        single_address:town,
        address: sortedAddress,
        city_id: "",
        town_id: "",
      };

      setCurLocation(newLocation); // state updated
      sessionStorage.setItem("cur_location", JSON.stringify(newLocation));



    }
    setLocationChangedByUser(true);
  };

  const setTownLocation = (townName,town_id,pincode,city) => {
    var townName1=townName+' '+pincode;
     const newLocation = {
      lat: "",
      lng: "",
      single_address:townName,
      address: townName1,
      city_id: city,
      town_id: town_id,
    };
    setCurLocation(newLocation);
    sessionStorage.setItem("cur_location", JSON.stringify(newLocation));
    setLocationChangedByUser(true);
  };

  return (
    <LocationContext.Provider value={{ cur_location,getCurrentLocation,setTownLocation,locationChangedByUser }}>
      {children}
    </LocationContext.Provider>
  );
};
